// extracted by mini-css-extract-plugin
export default {"burgerBtn":"BurgerButton_burgerBtn__GpEE+","burger":"BurgerButton_burger__mgmsx"};